"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Progress } from "@/components/ui/progress";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const testimonials = [{
    quote: "We contracted with Meir after purchasing a home with home with significant undisclosed water and mold issues and an initial mold inspection that proved to be highly ineffective. Meir was so understanding, knowledgeable and responsive. He recognized how concerned we were, got out to us right away, found and explained everything, and expedited a thoughtful plan to restore our home to a safe condition. I cannot say enough about the quality of his work or his professionalism. If you need a mold inspection, MYB is the only service to call!",
    name: "Mike & Megan Ruotolo",
    role: "Homeowner, Deerfield Beach",
    avatar: "",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_robert.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_robert.webp-wvc-sizes",
    rating: 5
  }, {
    quote: "I was very thankful for their expertise, professionalism and honest testing results. The testing on the air quality in my home showed no mold and I received a clearance certificate. Thank you! MYB",
    name: "Catherin Delutri",
    role: "Homeowner, Fort Lauderdale",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_sarah.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_sarah.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_sarah.webp-wvc-sizes",
    rating: 5
  }, {
    quote: "I wanted to personally thank the MYB team for their quick response and professional expertise. I would without hesitation recommend this team.",
    name: "Bob Demmery",
    role: "Business Owner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_michael.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_michael.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_michael.png-wvc-sizes",
    rating: 5
  }, {
    quote: "I have never met a gentleman so professional, honest, reliable and caring. Meier go way above what his responsibilities are. He was in our apartment to fix a mold problem and paused that job for 30 minutes to fix an air conditioning leak... He is so fair in his pricing and does an extraordinary job. I wish the world had more people like him... Thank you Meierfor all your hard work. We will never forget you. Helena and Mark Litowitz",
    name: "Helena Litowitz",
    role: "Homeowner, Boca Raton",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_elena.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_elena.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_elena.png-wvc-sizes",
    rating: 5
  }, {
    quote: "I would like to thank MYB services for their professionalism and dillegence in making a great sure that not only one of my houses, but two of them were inspected and now mold free. I have and will continue to recommend them to anyone looking for mold testing and/or remediation. Thank you, and job well done ",
    name: "Scott Burney",
    role: "Real Estate Investor",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_david.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_david.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_david.png-wvc-sizes",
    rating: 5
  }, {
    quote: "Meir was extremely helpful and professional throughout the whole process. He came highly recommended from a mold remediation company we dealt with in order to get to the bottom of our mold issue. We’re so glad we went with Meir and his Sevices. The report we received back was very extensive and outlined everything we needed to know. He explained to us what he was doing the whole time and provided us with all the necessary documentation. If you need immediate help call Meir!",
    name: "Diana T.",
    role: "Homeowner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_diana.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_diana.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_diana.png-wvc-sizes",
    rating: 5
  }, {
    quote: "Meir was absolutely wonderful and I’m so grateful I found this mold testing service. I had called around getting quotes from other companies and they were all very pushy to upsell and felt like scams, so when I connected with Meir it was such a relief as he was very honest and came out immediately to test for mold. He offered straight forward feedback and relieved a lot of concerns I had. He’s also a lovely person with a good heart. Highly recommend this company and Meir!!!",
    name: "Katelyn Gimbel",
    role: "Homeowner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_katelyn.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_katelyn.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721825/img/client_katelyn.png-wvc-sizes",
    rating: 5
  }, {
    quote: "I’ve used Meir at MYB a number of times for different properties. He’s amazing and I’d highly recommend. Professional, fairly priced, high quality work.",
    name: "Brandon",
    role: "Verified Client",
    avatar: "",
    avatarSrcset: "",
    avatarSizes: "",
    rating: 5
  }, {
    quote: "This company is so professional. In the midst of a disaster for my home, Mayor did very precise and detailed work and reports were delivered quickly, as well. A lot of times companies try and take advantage but MYB actually cares to do a great job and look out for their clients! So happy we went with them. Highly recommend.",
    name: "Erika Garcia",
    role: "",
    avatar: "Google Verified Customer",
    avatarSrcset: "",
    avatarSizes: "",
    rating: 5
  }, {
    quote: "After considerable research, I was able to find MYB Services to do a mold assessment on my home. It was important for me to find a testing company that was State certified and not remediation. Mr Meir has been doing this work for 30 years and is extremely knowledgeable. He was very helpful explaining the testing process and showing me exactly how he gathered his samples. My 47 page report was very thorough and detailed explaining issues that required additional follow-up. After reviewing his report, I was able to call him and ask additional questions which he explained leaving me very satisfied with the outcome. Mr Meir is a wealth of information and he was happy passing his knowledge on to me. He did an excellent job overall and I would highly recommend him.",
    name: "James Loftus",
    role: "Angi's List Verified Client",
    avatar: "",
    avatarSrcset: "",
    avatarSizes: "",
    rating: 5
  }];
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const progressValue = count > 1 ? (current + 1) / count * 100 : 100;
  return <section data-section-id="2449" id="verified-client-outcomes" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-lg opacity-20 blur-3xl" style={{
      background: "radial-gradient(circle, hsl(208 72% 50%) 0%, transparent 70%)"
    }} />

      <div ref={ref} className={`relative z-10 mx-auto max-w-7xl px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-16 flex flex-col items-center text-center md:mb-20">
          <span className="font-default mb-6 text-xs uppercase tracking-[0.3em]" style={{
          color: "hsl(208 72% 50%)"
        }}>
            Client Evidence
          </span>
          <h2 className="font-default text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-[56px]">
            Verified Clinical Outcomes.
          </h2>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: false,
        dragFree: false
      }} className="w-full">
          <CarouselContent className="-ml-6">
            {testimonials.map((t, i) => <CarouselItem key={i} data-index={i} className="basis-full pl-6 md:basis-1/2 lg:basis-1/3">
                <article className="group relative flex h-full flex-col justify-between border border-border/60 bg-card/40 p-8 backdrop-blur-sm transition-all duration-500 hover:border-blue-500/40 md:p-12" style={{
              borderRadius: "var(--radius-lg)"
            }}>
                  <Quote className="mb-6 h-16 w-16 -translate-x-2" strokeWidth={1} style={{
                color: "hsl(208 72% 50%)"
              }} />

                  <p className="font-default text-xl font-normal leading-[1.55] text-foreground/85">
                    {t.quote}
                  </p>

                  <div className="mt-10">
                    <Separator className="bg-border/60" />

                    <div className="mt-6 flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <SafeHydrate><Avatar className="h-11 w-11 border border-border/60">
                          <AvatarImage src={t.avatar} data-wvc-srcset={t.avatarSrcset} data-wvc-sizes={t.avatarSizes} alt={t.name} />
                          <AvatarFallback className="bg-muted text-xs text-foreground">
                            {t.name.split(" ").map(n => n[0]).join("")}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div className="flex flex-col">
                          <span className="font-default text-sm font-semibold text-foreground">
                            {t.name}
                          </span>
                          <span className="font-default text-xs uppercase tracking-wider text-muted-foreground">
                            {t.role}
                          </span>
                        </div>
                      </div>

                      <div className="flex items-center gap-1">
                        {Array.from({
                      length: t.rating
                    }).map((_, idx) => <Star key={idx} className="h-3.5 w-3.5" fill="hsl(208 72% 50%)" stroke="hsl(208 72% 50%)" />)}
                      </div>
                    </div>
                  </div>
                </article>
              </CarouselItem>)}
          </CarouselContent>

          <div className="mt-12 flex flex-col items-start gap-6 md:mt-16 md:flex-row md:items-center md:justify-between">
            <div className="flex w-full items-center gap-4 md:max-w-md">
              <span className="font-mono text-xs text-muted-foreground">
                {String(current + 1).padStart(2, "0")}
              </span>
              <Progress value={progressValue} className="h-px flex-1 bg-border/50" />
              <span className="font-mono text-xs text-muted-foreground">
                {String(count).padStart(2, "0")}
              </span>
            </div>

            <div className="flex items-center gap-3 self-end md:self-auto">
              <Button variant="outline" size="icon" onClick={() => api?.scrollPrev()} className="h-11 w-11 rounded-lg border-blue-500/40 bg-transparent text-blue-600 hover:bg-blue-50 hover:text-blue-700" aria-label="Previous testimonial">
                <ChevronLeft className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="icon" onClick={() => api?.scrollNext()} className="h-11 w-11 rounded-lg border-blue-500/40 bg-transparent text-blue-600 hover:bg-blue-50 hover:text-blue-700" aria-label="Next testimonial">
                <ChevronRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </Carousel>
      </div>
    </section>;
}